import React from "react";
import PersonalInfo from "../components/PersonalInfo";

const PersonalInfoScreen = (props) => {
  return <PersonalInfo {...props} />;
};
export default PersonalInfoScreen;
